// extracted by mini-css-extract-plugin
module.exports =  {"mobile-btn":"_0d624b9a27--mobile-btn--L66Nq","mobile-wrapper":"_0d624b9a27--mobile-wrapper--NjtHt"};